import { useState, useEffect } from "react";

import Navigation from "../components/general/Navigation";
import Banner from "../components/general/Banner";
import Home from "../components/home/Home";
import AboutMe from "../components/about-me/AboutMe";
import Work from "../components/work/Work";
import { RELEASED_GAMES, LONG_PROJECTS, GAME_JAMS, OTHER_PROJECTS, TOOLS, HARDWARE, ART } from "./ProjectList"
import ProjectCollection from "../components/projects/ProjectCollection";
import Footer from "../components/general/Footer";
import ProjectExpandedView from "../components/projects/ProjectExpandedView";
import ArtExpandedView from "../components/art/ArtExpandedView"

import classes from "./MainPage.module.css";

function MainPage() {
    const [activeCategory, setActiveCategory] = useState("about");

    const categories = [
        /*{ id: "home", name: "Home", component: <Home /> },*/
        { id: "about", name: "About Me", component: <AboutMe /> },
        /*{ id: "work", name: "Work Experience", component: <Work /> },*/
        { id: "game-releases", name: "Game Releases", component: <ProjectCollection data={RELEASED_GAMES} expandedView={ProjectExpandedView} /> },
        { id: "long-term-projects", name: "Long Projects", component: <ProjectCollection data={LONG_PROJECTS} expandedView={ProjectExpandedView} /> },
        { id: "game-jams", name: "Game Jams", component: <ProjectCollection data={GAME_JAMS} expandedView={ProjectExpandedView} /> },
        { id: "other-projects", name: "Other Games", component: <ProjectCollection data={OTHER_PROJECTS} expandedView={ProjectExpandedView} /> },
        { id: "tools", name: "Technical Samples & Tools", component: <ProjectCollection data={TOOLS} expandedView={ProjectExpandedView} /> },
        { id: "hardware", name: "Hardware & Electronics", component: <ProjectCollection data={HARDWARE} expandedView={ProjectExpandedView} /> },
        { id: "art", name: "Art, Cinematics and VFX", component: <ProjectCollection data={ART} expandedView={ArtExpandedView} /> },
    ];

    const midpoint = Math.ceil(categories.length / 2); // Determine split point
    const row1 = categories.slice(0, midpoint);
    const row2 = categories.slice(midpoint);

    return (
        <div className={classes.body}>
            <Navigation bgColor="#141414" />
            <section id="home">
                <Banner />
            </section>
            <div className={classes.grid}>
                {row1.map((category) => (
                    <button
                        key={category.id}
                        className={`${classes.button} ${
                            activeCategory === category.id ? classes.active : ""
                        }`}
                        onClick={() => setActiveCategory(category.id)}
                    >
                        {category.name}
                    </button>
                ))}
            </div>
            <div className={classes.grid}>
                {row2.map((category) => (
                    <button
                        key={category.id}
                        className={`${classes.button} ${
                            activeCategory === category.id ? classes.active : ""
                        }`}
                        onClick={() => setActiveCategory(category.id)}
                    >
                        {category.name}
                    </button>
                ))}
            </div>
            <section id={activeCategory} className={classes.category}>
                <div className={classes.content}>
                    {categories.find((cat) => cat.id === activeCategory)?.component}
                </div>
            </section>
            <Footer pad={true} bgColor="#BA9871" />
        </div>
    );
}

export default MainPage;
